import { User } from '@fc-core';
import { createAction, props } from '@ngrx/store';

export const currentUserError = createAction(
  '[CurrentUser/API] Current User Error',
  props<{ err: any }>(),
);

export const retrieveCurrentUser = createAction(
  '[CurrentUser] Retrieve current user from the api',
);

export const retrieveCurrentUserSuccess = createAction(
  '[CurrentUser] Retrieve current user from the api success',
  props<{ user: User }>(),
);

export const logOutCurrentUserAction = createAction(
  '[CurrentUser] Log User out',
);
